import React from "react";
import CommentsComponent from "../../comments/comments";
import { useParams } from "react-router-dom";

const LeadCommentsList = () => {
  const { id } = useParams();
  return (
    <main>
      <CommentsComponent tableName={"lead"} viewId={id} />
    </main>
  );
};

export default LeadCommentsList;
